document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-kp-open]');
  if (trigger) return openPopup(trigger);

  if (e.target.closest('[data-kp-close]')) closePopup();
});

function openPopup(trigger) {
  const popup = document.getElementById('kp-rs-popup');
  if (!popup) return;

  document.getElementById('kp-rs-product-title').textContent =
    trigger.dataset.productTitle;

  popup.dataset.productUrl = trigger.dataset.productUrl;

  const sizeSelect = document.getElementById('kp-rs-size');
  const noteField = document.querySelector(
    '#kp-rs-form textarea[name="note"], #kp-rs-form [name="note"]'
  );

  // Reset size dropdown
  sizeSelect.innerHTML = '<option value="">— Select size —</option>';

  // Add product variant sizes
  (trigger.dataset.sizes || '')
    .split(',')
    .filter(Boolean)
    .forEach(function (s) {
      const opt = document.createElement('option');
      opt.value = s.trim();
      opt.textContent = s.trim();
      sizeSelect.appendChild(opt);
    });

  // Add Other option
  const otherOption = document.createElement('option');
  otherOption.value = 'Other';
  otherOption.textContent = 'Other';
  sizeSelect.appendChild(otherOption);

  // Reset note field
  if (noteField) {
    noteField.required = false;
    noteField.placeholder = 'Message (optional)';
  }

  // Reset form state
  document.getElementById('kp-rs-form').style.display = '';
  document.getElementById('kp-rs-success').style.display = 'none';
  document.getElementById('kp-rs-error').style.display = 'none';

  popup.style.display = 'flex';
}

function closePopup() {
  document.getElementById('kp-rs-popup').style.display = 'none';
}


/*
 * When "Other" is selected,
 * make the message field required and update its placeholder.
 */
document.getElementById('kp-rs-size').addEventListener('change', function () {
  const noteField = document.querySelector(
    '#kp-rs-form textarea[name="note"], #kp-rs-form [name="note"]'
  );

  if (!noteField) return;

  if (this.value === 'Other') {
    noteField.required = true;
    noteField.placeholder = 'Please mention the size you require *';
  } else {
    noteField.required = false;
    noteField.placeholder = 'Message (optional)';
  }
});


document.getElementById('kp-rs-form').addEventListener('submit', function (e) {
  e.preventDefault();

  const form = e.target;
  const popup = document.getElementById('kp-rs-popup');
  const errorEl = document.getElementById('kp-rs-error');

  const selectedSize = document.getElementById('kp-rs-size').value;
  const noteValue = form.note.value.trim();

  // Validation for Other option
  if (selectedSize === 'Other' && !noteValue) {
    errorEl.textContent =
      'Please mention the size you require in the message field.';
    errorEl.style.display = 'block';
    return;
  }

  errorEl.style.display = 'none';

  const formData = new FormData();

  formData.append('form_type', 'contact');
  formData.append('utf8', '✓');
  formData.append('contact[name]', form.name.value);
  formData.append('contact[phone]', form.phone.value);
  formData.append('contact[email]', form.email.value);
  formData.append('contact[tags]', 'Size Request');

  let requestedSize = selectedSize;

  // Make the submission clearer when Other is selected
  if (selectedSize === 'Other') {
    requestedSize = 'Other — ' + noteValue;
  }

  formData.append(
    'contact[body]',
    'Product: ' +
      document.getElementById('kp-rs-product-title').textContent +
      ' — ' +
      window.location.origin +
      popup.dataset.productUrl +
      '\nSize requested: ' +
      requestedSize +
      '\nNote: ' +
      form.note.value
  );

  fetch('/contact', {
    method: 'POST',
    body: formData
  })
    .then(function (res) {
      if (!res.ok) throw new Error();

      form.style.display = 'none';
      document.getElementById('kp-rs-success').style.display = 'block';
    })
    .catch(function () {
      errorEl.textContent =
        'Something went wrong. Please try again.';
      errorEl.style.display = 'block';
    });
});